import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import NoData from "assets/svgs/no_data/NoData";
import classNames from "classnames";
import { fourPlaceHolder } from "modules/utilities/utility";
import React, { useState } from "react";


function CampaignTable({ mappedKey, utmLoading, mergedData,opa,opa1, handleSortGross, handleSortCount}) {
  const calculatePercentage = (todayResponse, yesterdayResponse) => {
    const todayResponseSum = Number(todayResponse);
    const yesterdayResponseSum = Number(yesterdayResponse);
    let returnSum = 0;
    if (todayResponseSum > yesterdayResponseSum) {
      returnSum =
        ((todayResponseSum - yesterdayResponseSum) / yesterdayResponseSum) *
        100;
    } else if (todayResponseSum < yesterdayResponseSum) {
      returnSum =
        ((yesterdayResponseSum - todayResponseSum) / yesterdayResponseSum) *
        100;
    } else {
      returnSum = 0;
    }
    return returnSum.toFixed(2);
  };

  return (
    <div>
      <div
        className="mt-1 shadow rounded mt-2 scrollable-container"
        style={{ maxHeight: "70vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top"
          style={{ position: "sticky", top: "0" }}
        >
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
            UTM Campaign Name
          </span>
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end" onClick={handleSortCount}>
            <span style={{ display: "inline-block", verticalAlign: "middle" }}>
              <span> Orders </span>
            </span>
            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                paddingLeft: "1rem",
              }}
            >
              <div
                className={
                  opa === ""
                    ? "opacity-100"
                    : opa === "asc"
                    ? "opacity-50"
                    : "opacity-100"
                }
              >
                <AscendingLogoGrey />
              </div>
              <div
                className={
                  opa === ""
                    ? "opacity-100 mt-n2"
                    : opa === "dsc"
                    ? "opacity-50 mt-n2"
                    : "opacity-100 mt-n2"
                }
              >
                <DescendingLogoGrey />
              </div>
            </div>
          </span>
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end" onClick={handleSortGross}>
            <span style={{ display: "inline-block", verticalAlign: "middle" }}>
              <span>Gross</span>
            </span>
            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                paddingLeft: "1rem",
              }}
            >
              <div
                className={
                  opa1 === ""
                    ? "opacity-100"
                    : opa1 === "asc"
                    ? "opacity-50"
                    : "opacity-100"
                }
              >
                <AscendingLogoGrey />
              </div>
              <div
                className={
                  opa1 === ""
                    ? "opacity-100 mt-n2"
                    : opa1 === "dsc"
                    ? "opacity-50 mt-n2"
                    : "opacity-100 mt-n2"
                }
              >
                <DescendingLogoGrey />
              </div>
            </div>
          </span>
        </div>
        {utmLoading ? (
          fourPlaceHolder()
        ) : mappedKey?.length ? (
          mappedKey?.map((item, index) => {
            const itemObj = mergedData[item];

            return (
              <div
                className={`d-flex table-row border-1 border-top-0 ${
                  index === mappedKey?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-3 flex-1 text-break text-black font-bold text-wrap border-end">
                  {itemObj?.today?.utm_campaign || "NULL"}
                </span>

                <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                  <p className="font-sans-serif lh-1 mb-1 fs-2">
                    {itemObj?.today?.count}
                  </p>
                  <div className="d-flex align-items-center">
                    <h6 className="fs--1 text-500 mb-0">
                      {itemObj?.yesterday?.count}
                    </h6>
                    <h6
                      className={classNames("fs--2 ps-3 mb-0", {
                        "text-success": "standard" === "up",
                        "text-danger": "standard" === "down",
                        "text-primary": "standard" === "standard",
                        "text-warning": "standard" === "warning",
                        "text-info": "standard" === "pending",
                      })}
                    >
                      <FontAwesomeIcon
                        icon={
                          Number(itemObj?.today?.count) >
                          Number(itemObj?.yesterday?.count)
                            ? "caret-up"
                            : "caret-down"
                        }
                        className={
                          Number(itemObj?.today?.count) <=
                          Number(itemObj?.yesterday?.count)
                            ? "me-1 text-danger"
                            : "me-1"
                        }
                      />
                      {calculatePercentage(
                        itemObj?.today?.count,
                        itemObj?.yesterday?.count
                      )}
                      %
                    </h6>
                  </div>
                </span>
                <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                  <p className="font-sans-serif lh-1 mb-1 fs-2">
                    &#x20B9; {itemObj?.today?.sum}
                  </p>
                  <div className="d-flex align-items-center">
                    <h6 className="fs--1 text-500 mb-0">
                      &#x20B9; {itemObj?.yesterday?.sum}
                    </h6>
                    <h6
                      className={classNames("fs--2 ps-3 mb-0", {
                        "text-success": "standard" === "up",
                        "text-danger": "standard" === "down",
                        "text-primary": "standard" === "standard",
                        "text-warning": "standard" === "warning",
                        "text-info": "standard" === "pending",
                      })}
                    >
                      <FontAwesomeIcon
                        icon={
                          Number(itemObj?.today?.sum) >=
                          Number(itemObj?.yesterday?.sum)
                            ? "caret-up"
                            : "caret-down"
                        }
                        className={
                          Number(itemObj?.today?.sum) <
                          Number(itemObj?.yesterday?.sum)
                            ? "me-1 text-danger"
                            : "me-1"
                        }
                      />
                      {calculatePercentage(
                        itemObj?.today?.sum,
                        itemObj?.yesterday?.sum
                      )}
                      %
                    </h6>
                  </div>
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default CampaignTable;
